import "./style.scss";

const Input = (props) => {
  return <input {...props} className="input" />;
};

export default Input;
